import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import { TikTokCampaignPricingModelEnum } from 'src/Types/campaigns'

interface GetTikTokCampaignBudgetRangeResponse {
  campaignMinBudget: number
  campaignMaxBudget: number
}

export interface GetSpotifyPaymentSettingsResponse {
  feedMatchingMinBudget: number
  manualMatchingMinBudget: number
}

export const artistPaymentSettingsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getTikTokCampaignBudgetRange: builder.query<
      GetTikTokCampaignBudgetRangeResponse,
      TikTokCampaignPricingModelEnum | null
    >({
      query: (pricingModel) => ({
        url: `${APP.TIKTOK_SERVER}/artist/payment-settings/tiktok`,
        method: 'get',
        params: pricingModel ? { pricingModel } : {},
      }),

      providesTags: ['TikTokMinBudget'],
    }),
    getSpotifyPaymentSettings: builder.query<
      GetSpotifyPaymentSettingsResponse,
      void
    >({
      query: () => ({
        url: `${APP.TIKTOK_SERVER}/artist/payment-settings/spotify`,
        method: 'get',
      }),
    }),
  }),
})
export const {
  useGetTikTokCampaignBudgetRangeQuery,
  useGetSpotifyPaymentSettingsQuery,
} = artistPaymentSettingsApi
